var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeThinSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#4f6ef7;stroke-linejoin:round;stroke-width:4px;}.a{stroke-linecap:round;opacity:0.25;}.b{stroke-linecap:square;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50,0a50,50,0,0,1,50,50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeThinSpinner);
export default __webpack_public_path__ + "static/media/large-thin-spinner.2909bb5106ef756eb9500952c234ed06.svg";
export { ForwardRef as ReactComponent };